<mat-card class="path-content">
  <mat-card-header class="flex-row header header-container">
    <ng-container *ngIf="canShowHeader(); else showActionButtons">
      <mat-card-title class="antialiased border-right data-header">
        <h4 class="font-weight-bold mr-16">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_CONTENT.PATH_CONTENT' | bmsTranslate }}</h4>
      </mat-card-title>

      <div class="flex-row">
        <div class="data-element gap-4 flex-row">
          <div class="b2 font-weight-regular ml-16">{{ 'ANGULAR_COMPONENT_LIBRARY.STATUS_BAR.ROWS' | bmsTranslate }}:</div>
          <div class="b2 font-weight-semibold mr-8">{{ this.listProductionScheduleItemInPathGroup?.length }}</div>
        </div>
      </div>
    </ng-container>
    <ng-template #showActionButtons>
      <section class="right-side flex-row gap-8">
        <button class="small-icon-button" [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MOVE_PATH_UP' | bmsTranslate" [disabled]="!canMovePath(true)" (click)="movePath(true)">
          <mat-icon class="small-icon" svgIcon="arrow-up-small"></mat-icon>
        </button>
        <button class="small-icon-button" [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MOVE_PATH_DOWN' | bmsTranslate" [disabled]="!canMovePath(false)" (click)="movePath(false)">
          <mat-icon class="small-icon" svgIcon="arrow-down-small"></mat-icon>
        </button>
        <button class="small-icon-button" [matTooltip]="'ANGULAR_COMPONENT_LIBRARY.HEADER.EDIT' | bmsTranslate" [disabled]="!canEditPath()" (click)="openEditProductionScheduleItemDialog()">
          <mat-icon class="small-icon" svgIcon="edit"></mat-icon>
        </button>
        <button class="small-icon-button" [matTooltip]="'ANGULAR_COMPONENT_LIBRARY.HEADER.DELETE' | bmsTranslate" (click)="deletePath()">
          <mat-icon class="small-icon" svgIcon="trash-small"></mat-icon>
        </button>
      </section>
    </ng-template>
  </mat-card-header>

  <mat-card-content #pathsContainer class="full-height path-content-container">
    <div class="full-height flex-column">
      <ag-grid-angular
        #pathContentGrid
        class="ag-theme-vdw full-width ag-grid-compact-view"
        [gridOptions]="gridOptions"
        [rowData]="listProductionScheduleItemInPathGroup"
        (rowDragEnter)="onRowDragEnter($event)"
        (rowDragEnd)="onRowDragEnd($event)"
      ></ag-grid-angular>
    </div>
  </mat-card-content>
</mat-card>
